import { __assign, __rest } from "tslib";
import React from 'react';
import FormControlLabel from './FormControlLabel';
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
/**
 * @ReactHighOrderComponent
 *
 * 添加标签的高阶组件
 *
 * @template V 包含组件的值类型
 * @template P 包含组件的属性类型
 * @param {string} displayName 组件名称
 * @returns 返回包装后的组件
 */
function withLabel(displayName) {
    return function (BaseComponent) {
        var FormControlWithLabel = function (_a) {
            var children = _a.children, labelPosition = _a.labelPosition, props = __rest(_a, ["children", "labelPosition"]);
            if (!children) {
                return React.createElement(BaseComponent, __assign({}, props));
            }
            return (React.createElement(FormControlLabel, { labelPosition: labelPosition, label: children, control: React.createElement(BaseComponent, __assign({}, props)) }));
        };
        if (process.env.NODE_ENV !== 'production') {
            FormControlWithLabel.displayName = "withLabel" + getDisplayName(BaseComponent);
        }
        return FormControlWithLabel;
    };
}
export default withLabel;
//# sourceMappingURL=withLabel.js.map